import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'rr-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
})
export class ModalHeaderComponent {
  @Output() closeButtonClicked: EventEmitter<void> = new EventEmitter();
  constructor() {}

  public onClose() {
    this.closeButtonClicked.emit();
  }
}
